import type { ParamSpec } from "@/api/types";

/** Wire shape from backend commit f31ed04+ (`configurable.params`). */
export interface ParamsResponse {
  params?: ParamSpec[];
  warning?: string;
}

/**
 * Normalize `configurable.params` responses.
 * Newer backends return `{ params, warning? }`; older ones returned a bare array.
 * Treating the object as non-array previously yielded `[]` and stripped `source` on save.
 */
export function normalizeConfigurableParams(raw: unknown): {
  specs: ParamSpec[];
  warning?: string;
} {
  if (Array.isArray(raw)) {
    return { specs: raw as ParamSpec[] };
  }
  if (raw && typeof raw === "object") {
    const obj = raw as ParamsResponse;
    if (Array.isArray(obj.params)) {
      return {
        specs: obj.params,
        warning: typeof obj.warning === "string" && obj.warning ? obj.warning : undefined,
      };
    }
  }
  return { specs: [] };
}
